import { Circle4 } from "vue-loading-spinner";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import DataForm from "@/dataForm/dataFormDaiLy";
import mushroom from "viettoc-api";
import moment from "moment";

export default {
  data() {
    return {
      loading: true,
      aLang: LanguageService.lang,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
        typeAgent: MethodService.copyObject(DataForm.typeAgent),
        statusAgent: MethodService.copyObject(DataForm.statusAgent),
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: this.mData.tableRules.fields,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachDaiLy",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }

      try {
        const response = await mushroom.agt_dai_ly.listAsync(dataFilter);
        this.mData.tableRules.data = response.result;
        this.mData.tableRules.total = response.meta.total;
        this.mData.tableRules.page =
          response.meta.offset / response.meta.limit + 1;
      } catch (e) {
        MethodService.showError(e.code);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachDaiLy",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ten"]) {
        this.mData.tableRules.dataSearch.value["ten"] =
          this.mData.tableRules.dataSearch.value["ten"].trim();
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietDaiLy",
          params: { id: row.id },
        });
        // alert("Chức năng đang hoàn thiện!")
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatDaiLy",
          params: { id: row.id },
        });
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_themMoiDaiLy() {
      this.$router.push({
        name: "ThemMoiDaiLy",
      });
    },
    fn_formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    fn_renderTypeAgent(type) {
      switch (type) {
        case "doanh_nghiep":
          return `<div class="type-agent type-agent__doanh-nghiep">Doanh nghiệp</div>`;
        case "ca_nhan":
          return `<div class="type-agent type-agent__ca-nhan">Cá nhân</div>`;
        default:
          return "";
      }
    },
    fn_renderStatusAgent(status) {
      switch (status) {
        case "cho_duyet":
          return `<div class="status__waiting">Chờ duyệt</div>`;
        case "hoat_dong":
          return `<div class="status__active">Hoạt động</div>`;
        case "ngung_hop_tac":
          return `<div class="status__hold">Ngừng hợp tác</div>`;
        case "huy":
          return `<div class="status__cancel">Hủy</div>`;
        default:
          return "";
      }
    },
  },

  async created() {
    this.fn_hashUrl();
    await this.fn_initTable();
  },
};
